import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalButtonColor, ModalIconType, ModalType } from '../enums/modal';
import { UtilService } from './util.service';
import { CtDialogComponent, CtViewComponent, AlertDialogComponent } from '../controls';
import { Observable, Observer, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlusAlertsService {

  cbConfirm;

  public canBeClosed: boolean = true;


  private type: ModalType;

  private ptitle: string;
  private pmodalType: ModalType;
  private pmodalIconType: ModalIconType;
  private pmodalButtonColor: ModalButtonColor = ModalButtonColor.primary;
  private pdescription: string;
  public pcanBeClosed: boolean = true;
  private pactionButtonText: string = "Confirmar";
  private pcancelButtonText: string = "Regresar";
  private unSavedData: boolean = false;
  private unSavedView: boolean = false;
  private $continueFlag: Observable<boolean>;
  private continueFlag: Subject<boolean>;
  private cbStay: any;
  private cbRetry: any;

  /*Modal properties*/
  private dialogText: string;
  private confirmText: string;
  private notConfirmText: string;
  private alertTemplateRef: BsModalRef;
  private container: ViewContainerRef;
  public ctDialog: CtDialogComponent;
  public publicDialogContainerRef : ViewContainerRef

  constructor(private modalService: BsModalService, private utilService: UtilService,
    private componentFactoryResolver: ComponentFactoryResolver) {

    this.continueFlag = new Subject<boolean>();
    this.$continueFlag = this.continueFlag.asObservable();
  }

  setDefaultConfirmText(type) {
    switch (type) {
      case 'DEL':
        this.setDialogText("¿Seguro que desea eliminar el registro?");
        this.setConfirmText("Eliminar");
        break;
      case 'UPD':
        this.setDialogText("¿Seguro que desea actualizar el registro?");
        this.setConfirmText("Actualizar");
        break;
      case 'OUT':
        this.setDialogText("Parece que hay cambios sin guardar<br>¿Desea salir realmente?");
        this.setConfirmText("Salir");
        break;
      case 'SVW':
        this.setDialogText("Parece que vas hacia otro lugar, <br>¿Te gustaría conservar el avance del proceso?");
        this.setConfirmText("Si, guardar");
        break;
      case 'LGN':
        this.setDialogText("Parece que tienes otra sesión abierta en otro lugar, <br>¿Te gustaría cerrarla y continuar aquí?");
        this.setConfirmText("Si, continuar aquí");
        break;
      case 'OTP':
        this.setDialogText("Hemos enviado un código de verificación al medio de contacto ingresado.<br><br>Por favor ingrese el código que recibió en el siguiente en el campo de \"Código de verificación\" y posteriormente presione el botón de \"Continuar\".");
        this.setConfirmText("Continuar");
        break;
      default:
        this.setDialogText("¿Seguro que desea ejecutar la acción?");
        this.setConfirmText("Ejecutar");
        break;
    }

    this.setNotConfirmText("Cancelar");
  }



  showConfirmModal(pcbConfirm, pcbStay = null, pCbRetry = null, modalType = null, adnField = null, inputLabel = null): Observable<boolean> {

    if (modalType != 'OTP') {
      this.setCtDialogInfo('Confirmación', 'confirmation', 'send', 'primary', this.getDialogText(), true, this.getConfirmText(), 'Cancelar');
    } else {

      const initialState = {
        title: 'Confirmación',
        message: this.getDialogText(),
        type: modalType == 'OTP' ? modalType : 'def',
        adnFieldName: adnField ? adnField : '@OTP',
        inputLabel: inputLabel ? inputLabel : 'Código de verificación:',
        doneBtnName: this.getConfirmText(),
        closeBtnName: 'Cancelar',
      }

      this.cbConfirm = pcbConfirm;
      this.cbStay = pcbStay;
      this.cbRetry = pCbRetry;

      this.alertTemplateRef = this.modalService.show(AlertDialogComponent, { initialState });

      this.alertTemplateRef.content.onCancelBtn.subscribe((modal) => {
        this.cbConfirm = null;
        this.cbStay ? this.cbStay(modal) : null;
        this.cbStay = null;
        this.cbRetry = null;
        let r = false;
        if ((this.getUsavedView() && !this.getUsavedData())) {
          r = true;
          this.setUsavedView(false);
        }
        this.getObserver().next(r);
      })

      this.alertTemplateRef.content.onDoneBtn.subscribe((modal) => {
        this.cbConfirm ? this.cbConfirm(modal) : null;
        if (modalType != 'OTP') {
          this.clearCallbacks()
        }
        this.getObserver().next(true);
      })

      this.alertTemplateRef.content.onRetryBtn.subscribe((modal) => {
        this.cbRetry ? this.cbRetry(modal) : null;
      })

      return this.getContinueFlag();

    }
  }



  showAlertDialog(ptitle: string, pmessage: string, ptype: string, pdoneBtn: string = null, pcancelBtn: string = null, cbConfirm = null) {
    const initialState = {
      title: ptitle,
      message: pmessage,
      type: ptype,
      doneBtnName: pdoneBtn,
      canceleBtnName: pcancelBtn,
    };
    this.cbConfirm = cbConfirm;

    this.alertTemplateRef = this.modalService.show(AlertDialogComponent, { initialState });

    this.alertTemplateRef.content.onDoneBtn.subscribe((modal) => {
      this.cbConfirm ? this.cbConfirm(modal) : null;
      this.cbConfirm = null;
    })
  }

  setCtDialogInfo(_ptitle: string, _pmodalType: string, _pmodalIconType: string, _pmodalButtonColor: string, _pdescription: string, _pcanBeClosed: boolean = true, _pactionButtonText: string = "Confirmar", _pcancelButtonText: string = "Regresar", container: ViewContainerRef = null) {
    this.ptitle = _ptitle;
    this.setModalType(_pmodalType);
    this.setModalIconType(_pmodalIconType);
    this.setModalButtonColor(_pmodalButtonColor);
    this.pdescription = _pdescription;
    this.pcanBeClosed = _pcanBeClosed;
    this.pactionButtonText = _pactionButtonText;
    this.pcancelButtonText = _pcancelButtonText;

    if(container){
      this.container = container;
      this.paintDialog();

      return this.ctDialog;
    }

    this.showDialog();
    return this.ctDialog;
  }

  public showDialog() {
    this.container = this.getContainer();
    this.paintDialog();
  }

  /**
   * Public function to hide the currently displayed message.
   */
  public hideDialog() {
    this.container.clear();
  }

  clearCallbacks() {
    this.cbRetry = null;
    this.cbStay = null;
    this.cbConfirm = null;
  }

  /**
   * Private function to obtain the container for the message component.
   * @returns ViewContainerRef - The container for the message component.
   */
  private getContainer(): ViewContainerRef {
    if(this.publicDialogContainerRef) return this.publicDialogContainerRef; //for public views
    const component: CtViewComponent = this.utilService.getComponentRef(this.utilService.currentViewId).getRoot();
    return component.dialogContainer;
  }

  /**
   * Private function to create and insert the message component in the container.
   */
  private paintDialog() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CtDialogComponent);
    this.container.clear();
    this.ctDialog = this.container.createComponent(componentFactory).instance;
    this.setDialogData();
    this.ctDialog.openDialog();
  }

  public closeDialog() {
    this.ctDialog.closeDialog();
  }

  private setDialogData() {
    this.ctDialog.setMetaData({
      ctType: "CtDialog",
      controlProperties: {
        cancelButtonText: this.pcancelButtonText,
        actionButtonText: this.pactionButtonText,
        autoOpen: false,
        canBeClosed: this.pcanBeClosed,
        width: 500.0,
        id: "CtDialog_default",
        description: this.pdescription,
        modalButtonColor:  this.pmodalButtonColor,
        modalIconType: this.pmodalIconType,
        modalType: this.pmodalType,
        title: this.ptitle,

      },
      controlActions: [],
      models: []
    });
  }

  setUsavedData(unSavedData: boolean): void { this.unSavedData = unSavedData }
  setUsavedView(unSavedView: boolean): void { this.unSavedView = unSavedView }
  setDialogText(dialogText: string): void { this.dialogText = dialogText }
  setConfirmText(confirmText: string): void { this.confirmText = confirmText }
  setNotConfirmText(notConfirmText: string): void { this.notConfirmText = notConfirmText }
  
  setModalIconType(temp: string): ModalIconType {
    const iconType : ModalIconType = ModalIconType[temp as keyof typeof ModalIconType];
    this.pmodalIconType = iconType;
    return this.pmodalIconType;
  }

  setModalType(temp: string): ModalType {
    const modalTypeEnum = ModalType[temp as keyof typeof ModalType];
    if (modalTypeEnum !== undefined) {
        this.pmodalType = modalTypeEnum;
    }
    return this.pmodalType;
  }
    
  setModalButtonColor(temp: string): ModalButtonColor {
    const modalButtonColorEnum = ModalButtonColor[temp as keyof typeof ModalButtonColor];
    if (modalButtonColorEnum !== undefined) {
        this.pmodalButtonColor = modalButtonColorEnum;
    }
    return this.pmodalButtonColor;
  }

  getUsavedData(): boolean { return this.unSavedData }
  getUsavedView(): boolean { return this.unSavedView }
  getContinueFlag(): Observable<boolean> { return this.$continueFlag }
  getObserver(): Observer<boolean> { return this.continueFlag }
  getDialogText(): string { return this.dialogText }
  getConfirmText(): string { return this.confirmText }
  getNotConfirmText(): string { return this.notConfirmText }
}